import React from "react";
import Card from "./components/card"

function App() {
  return (
    <div className="App">
      <section className="container">
        <Card/>
      </section>
    </div>
  );
}



export default App;